export default (axios) => axios.get('/wallet/');
